import { IMobileSdkTestDetails } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import { MOBILE_SDK_TYPES_MAP } from 'src/common/helpers/MobileQueriesHelper';

import { MobileSdkTestDetailsQuery } from '../MobileSdkTestDetails.generated';

export const transformMobileSdkTestDetailsResults = (
	result: MobileSdkTestDetailsQuery
): IMobileSdkTestDetails | null => {
	const testData = result.msdk_test_runs?.filter(returnNonNull)?.[0];

	if (!testData) {
		return null;
	}

	return {
		testName: testData.test_name ?? '',
		lastModified: testData.run_time,
		labels: testData.custom_fields?.flat().filter(Boolean) || [],
		appName: testData.app ?? '',
		appVersion: testData.app_version ?? '',
		sdkType: MOBILE_SDK_TYPES_MAP[testData.sdk_type] ?? '',
		productVersion: testData.product_version ?? ''
	};
};
